module.exports = __webpack_public_path__ + "img/busines-hand.3f1af71e.png";